import { createFileRoute } from "@tanstack/react-router"
import { StoreSizeBucketsPage } from "@/features/store-size-buckets/components/StoreSizeBucketsPage"
import { storeSizeBucketsQuery } from "@/features/store-size-buckets/core/useStoreSizeBuckets"

export const Route = createFileRoute("/(authenticated)/settings/store-sizes/")({
  loader: ({ context }) => {
    void context.queryClient.ensureQueryData(storeSizeBucketsQuery())
  },
  component: StoreSizeBucketsPage,
})
